import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import React from 'react';
import classnames from 'classnames';
import { Flex, PromoChip, Body, Button } from '@cognite/cogs-core';
import { getStatusIcon, CloseIcon } from '@cognite/cogs-icons';
import { getThemeClassNames } from '@cognite/cogs-utils';

/**
 * Banner is a component that is used to display information to the user.
 */
var Banner = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var className = _a.className,
    themeProps = _a.themeProps,
    _a$hideIcon = _a.hideIcon,
    hideIcon = _a$hideIcon === undefined ? false : _a$hideIcon,
    children = _a.children,
    promo = _a.promo,
    _a$status = _a.status,
    status = _a$status === undefined ? 'neutral' : _a$status,
    actions = _a.actions,
    onClose = _a.onClose,
    _a$solid = _a.solid,
    solid = _a$solid === undefined ? false : _a$solid,
    otherProps = __rest(_a, ["className", "themeProps", "hideIcon", "children", "promo", "status", "actions", "onClose", "solid"]);
  var Icon = getStatusIcon(status || 'neutral');
  return jsx("div", {
    className: classnames.apply(undefined, ['cogs-lab-banner-wrapper'].concat(_toConsumableArray(getThemeClassNames(undefined, themeProps)), [{
      'cogs-lab-banner-wrapper-solid': solid
    }])),
    children: jsxs("div", Object.assign({
      role: "banner",
      className: classnames('cogs-lab-banner', "cogs-lab-banner--status-".concat(status), className),
      ref: ref
    }, otherProps, {
      children: [jsxs(Flex, {
        className: classnames(!promo && hideIcon && 'cogs-lab-banner--hide-icon'),
        gap: 12,
        alignItems: "center",
        children: [(promo || !hideIcon) && jsxs(Flex, {
          alignItems: "center",
          gap: 12,
          className: "cogs-lab-banner-left-content",
          children: [promo && jsx(PromoChip, {
            children: promo
          }), !hideIcon && Icon && jsx(Icon, {
            width: 16,
            height: 16,
            className: "banner__icon"
          })]
        }), jsx(Body, {
          role: "heading",
          size: "medium",
          children: children
        })]
      }), jsxs(Flex, {
        gap: 16,
        alignItems: "center",
        children: [actions, onClose && jsx(Button, {
          icon: jsx(CloseIcon, {}),
          onClick: onClose,
          type: "ghost",
          "aria-label": "Close Banner",
          size: "small"
        })]
      })]
    }))
  });
});

export { Banner };
